import { createFileRoute, redirect } from "@tanstack/react-router";
import { DEFAULT_SETTING_KEY } from "@/pages/settings/nav";

// Bare /settings has no editor of its own — redirect to the first sub-setting.
export const Route = createFileRoute("/settings/")({
  beforeLoad: () => {
    throw redirect({
      to: "/settings/$settingKey",
      params: { settingKey: DEFAULT_SETTING_KEY },
    });
  },
});
